import {createAction} from 'redux-actions';

import {
  GET_SUMMARY_SUCCESS,
  GET_SUMMARY_FAIL,
  SET_SUMMARY_FETCHING,
  CLEAR_SUMMARY,
  SET_PURCHASE_LIMITS_EXCEEDED
} from '../config/const';

export const getSummarySuccess = createAction(GET_SUMMARY_SUCCESS, summary => summary);
export const getSummaryFail = createAction(GET_SUMMARY_FAIL);
export const setFetching = createAction(SET_SUMMARY_FETCHING, bool => bool);
export const clearSummary = createAction(CLEAR_SUMMARY);
export const setPurchaseLimitsExceeded = createAction(SET_PURCHASE_LIMITS_EXCEEDED, bool => bool);

const initialState = {
  summary: {},
  summaryIsFetching: false,
  purchaseLimitsExceeded: false
};
const summaryReducer = (state = initialState, action) => {
  switch (action.type) {
  case GET_SUMMARY_SUCCESS:
    return {
      ...state,
      summary: action.payload
    };
  case GET_SUMMARY_FAIL:
    return {
      ...state,
      summary: undefined,
    };
  case CLEAR_SUMMARY:
    return initialState;
  case SET_SUMMARY_FETCHING:
    return {
      ...state,
      summaryIsFetching: action.payload
    };
  case SET_PURCHASE_LIMITS_EXCEEDED:
    return {
      ...state,
      purchaseLimitsExceeded: action.payload
    };
  default:
    return state;
  }
};
export default summaryReducer;



// WEBPACK FOOTER //
// ./src/reducers/summaryReducer.js